import { Link } from "react-router-dom";
import { Cloud, GitBranch, MessageSquare } from "lucide-react";
import { CloudCard } from "@/components/settings/cloud-card";
import { GitHubCard } from "@/components/settings/github-card";
import { SlackCard } from "@/components/settings/slack-card";
import { MENU } from "@/components/new-look/labels";
import { Button } from "@/components/ui/button";
import { useIsOrgAdmin } from "@/hooks/queries/use-cloud";
import { usePageTitle } from "@/hooks/use-page-title";

/**
 * Connections: where GitHub, Google Cloud (and other clouds) and Slack are
 * linked. The cards moved here from Settings. Each card already limits
 * changes to admins (canManage) and shows members a read-only view.
 */
export function ConnectionsPage() {
  usePageTitle(MENU.connections);
  const isAdmin = useIsOrgAdmin();
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-6 py-6">
      <h1 className="text-3xl font-bold tracking-tight text-foreground">{MENU.connections}</h1>
      <p className="text-sm text-muted-foreground">
        Link GitHub, your cloud and Slack. Only admins can connect or change these; everyone else sees their status.
      </p>

      <section id="github" className="glass-card rounded-2xl border border-white/[0.08] p-6">
        <div className="mb-4 flex items-center gap-2">
          <GitBranch className="h-4 w-4 text-primary" />
          <h2 className="text-sm font-medium">GitHub</h2>
        </div>
        <GitHubCard />
      </section>

      <section id="cloud" className="glass-card rounded-2xl border border-white/[0.08] p-6">
        <div className="mb-4 flex items-center gap-2">
          <Cloud className="h-4 w-4 text-primary" />
          <h2 className="text-sm font-medium">Cloud</h2>
        </div>
        <CloudCard />
        {isAdmin && (
          <Button asChild size="sm" variant="outline" className="mt-3">
            <Link to="/connections/google-cloud">Connect Google Cloud (guided)</Link>
          </Button>
        )}
      </section>

      <section id="slack" className="glass-card rounded-2xl border border-white/[0.08] p-6">
        <div className="mb-4 flex items-center gap-2">
          <MessageSquare className="h-4 w-4 text-primary" />
          <h2 className="text-sm font-medium">Slack</h2>
        </div>
        <SlackCard />
      </section>
    </div>
  );
}
